import { render, staticRenderFns } from "./CoozzyFilterInitIcon.vue?vue&type=template&id=39b9845b&scoped=true"
import script from "./CoozzyFilterInitIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyFilterInitIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b9845b",
  null
  
)

export default component.exports